export const SET_BRANCH_INFO = 'SET_BRANCH_INFO';

export const setBranchInfo = (branchInfo) => ({
  type: SET_BRANCH_INFO,
  branchInfo,
});
